import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { EditIntegrationFormContext } from '../../editIntegration/types/EditIntegrationFormContext';

export const templateIntegrationCreatePanel = document.createElement('template');

templateIntegrationCreatePanel.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="wrapper">
    <div class="loading-container">
      <gz-progress-spinner size="large"></gz-progress-spinner>
    </div>

    <div class="content-wrapper">
      <gz-wizard class="add-integration-wizard"></gz-wizard>

      <div class="form-wrapper">
        <!-- Select Company -->
        <gz-integrations-select-company class="integration-type-list-wrapper"></gz-integrations-select-company>

        <!-- Select sensor -->
        <gz-integrations-integration-types-list class="integration-type-list-wrapper hidden"></gz-integrations-integration-types-list>

         <!-- Check Requirements -->
         <gz-integrations-requirements class="integration-type-list-wrapper hidden"></gz-integrations-requirements>

         <!-- Integration details -->
         <gz-integrations-edit-integration context="${EditIntegrationFormContext.Create}" class="integration-type-list-wrapper hidden"></gz-integrations-edit-integration>

         <!-- Finalize -->
         <gz-integrations-success class="integration-type-list-wrapper hidden"></gz-integrations-success>
      </div>

      <div class="bottom-buttons">
        <gz-tooltip id="apply-button-tooltip">
          <gz-button id="apply-button" class="hidden" type="full" disabled></gz-button>
        </gz-tooltip>
        <gz-button id="next-button" type="full" disabled></gz-button>
        <gz-button id="confirm-button" class="hidden" type="full" ></gz-button>
        <gz-button id="back-button" type="quiet" color="secondary" class="hidden"></gz-button>
        <gz-button id="close-button" type="full" class="hidden"></gz-button>
        <gz-button id="add-new-button" type="quiet" color="secondary" class="hidden"></gz-button>
        <div class="flex-auto"></div>
        <gz-button color="secondary" type="outline" id="cancel-button"></gz-button>
      </div>
    </div>
  </div>
`;
